
"use strict"; // jshint ignore:line


import { Oeuvre } from '../classes/oeuvre.js';
import { Painting } from '../classes/painting.js';
import { Statue } from '../classes/statue.js';
import { WallService }              from '../services/WallsHandlerService.js';
import { DragHandle }               from '../services/DragHandlesService.js';

const OEUVRE_TYPE                            = "oeuvre";
const PAINTING_TYPE                          = "oeuvre.painting";
const STATUE_TYPE                            = "oeuvre.statue";
const DRAGHANDLE_COMMENT_TYPE                = "dragHandle.comment";
const DRAGHANDLE_METER_TYPE                  = "dragHandle.meter";
const DRAGHANDLE_POLYGON_TYPE                = "dragHandle.polygon";
const ADDITIONALOBJECT_TYPE                  = "additionalObject";
const ADDITIONALOBJECT_CUBE_TYPE             = "additionalObject.cube";
const ADDITIONALOBJECT_JSON_TYPE             = "additionalObject.json";
const ADDITIONALOBJECT_TEXT_TYPE             = "additionalObject.text";
const ADDITIONALOBJECT_LIGHT_TYPE            = "additionalObject.light";
const ADDITIONALOBJECT_AMBIENTLIGHT_TYPE     = "additionalObject.light.AmbientLight";
const ADDITIONALOBJECT_DIRECTIONALLIGHT_TYPE = "additionalObject.light.DirectionalLight";
const ADDITIONALOBJECT_HEMISPHERELIGHT_TYPE  = "additionalObject.light.HemisphereLight";
const ADDITIONALOBJECT_POINTLIGHT_TYPE       = "additionalObject.light.PointLight";
const ADDITIONALOBJECT_SPOTLIGHT_TYPE        = "additionalObject.light.SpotLight";
const ADDITIONALWALL_TYPE                    = "additionalWall";

export const ObjectTypes = {
	OEUVRE_TYPE,
	PAINTING_TYPE,
	STATUE_TYPE,
	DRAGHANDLE_COMMENT_TYPE,
	DRAGHANDLE_METER_TYPE,
	DRAGHANDLE_POLYGON_TYPE,
	ADDITIONALOBJECT_TYPE,
	ADDITIONALOBJECT_CUBE_TYPE,
	ADDITIONALOBJECT_JSON_TYPE,
	ADDITIONALOBJECT_TEXT_TYPE,
	ADDITIONALOBJECT_LIGHT_TYPE,
	ADDITIONALOBJECT_AMBIENTLIGHT_TYPE,
	ADDITIONALOBJECT_DIRECTIONALLIGHT_TYPE,
	ADDITIONALOBJECT_HEMISPHERELIGHT_TYPE,
	ADDITIONALOBJECT_POINTLIGHT_TYPE,
	ADDITIONALOBJECT_SPOTLIGHT_TYPE,
	ADDITIONALWALL_TYPE
};

export default class ObjectSolverService {
	solveObjectType( object ) {

		if (object instanceof Oeuvre) {
		
			if (object instanceof Painting) return PAINTING_TYPE;
			if (object instanceof Statue)   return STATUE_TYPE;

			return OEUVRE_TYPE;
		}

		if (object instanceof DragHandle.Comment) return DRAGHANDLE_COMMENT_TYPE;
		if (object instanceof DragHandle.Meter)   return DRAGHANDLE_METER_TYPE;
		if (object instanceof DragHandle.Polygon) return DRAGHANDLE_POLYGON_TYPE;

		if (object instanceof AdditionalObject) {

			if (object instanceof AdditionalObject.Text) return ADDITIONALOBJECT_TEXT_TYPE;

			if (object instanceof AdditionalObject.Cube) return ADDITIONALOBJECT_CUBE_TYPE;
			
			if (object instanceof AdditionalObject.JSON) {
				/* Mites tässä vaikka liitetiedostot verkko-osoitteesta ladatuista oikeastaan eroaa? */
			}

			if (object instanceof AdditionalObject.Light && object.mesh) {

				switch (object.mesh.type) {
					case "AmbientLight":     return ADDITIONALOBJECT_AMBIENTLIGHT_TYPE;
					case "DirectionalLight": return ADDITIONALOBJECT_DIRECTIONALLIGHT_TYPE;
					case "HemisphereLight":  return ADDITIONALOBJECT_HEMISPHERELIGHT_TYPE;
					case "PointLight":       return ADDITIONALOBJECT_POINTLIGHT_TYPE;
					case "SpotLight":        return ADDITIONALOBJECT_SPOTLIGHT_TYPE;
				}

				return ADDITIONALOBJECT_LIGHT_TYPE;
			}

			return ADDITIONALOBJECT_TYPE;
		}

		if (object instanceof WallService.AdditionalWall) return ADDITIONALWALL_TYPE;

		//first.object.userData.type;

		return;
	}
}

import AdditionalObjectService from '../services/AdditionalObjectService.js';
import WallsHandlerService     from '../services/WallsHandlerService.js';
import OeuvresHandlerService   from '../services/OeuvresHandlerService.js';

/**
 * Selvitetään objekti UUID'n perusteella
 *
 * @param {}        uuid  -
 * @param {string} [type] - Tarkennetaan mistä haetaan, helpottaa hakua.
 * @returns [{Object}]
 */
export function ObjectSolverByUuid( uuid, type ) {
	switch ( type ) {
		case "AdditionalObject":
			return AdditionalObjectService.getInstance().objects[ uuid ];
			//return additionalObjectService.objects[ uuid ];
			break;
		case "AdditionalWall":
			return WallsHandlerService.getInstance().additional_walls[ uuid ];
			//return wallsHandlerService.additional_walls[ uuid ];
			break;
		case "oeuvre":
			return OeuvresHandlerService.getInstance().solveOeuvre( uuid );
			break;
		default:
			var	service;

			try {
				service = angular.element( document.body ).injector().get( type );
			} catch( error ) { }

			if (service && service.solveByUuid) {
				return service.solveByUuid( uuid );
			} else {
				console.warn( "ObjectSolverByUuid :: Invalid 'type'" );
			}
	}
}

